module.exports = __webpack_public_path__ + "assets/img/Structure_item10.0a830183.png";